import React, { useEffect } from "react";
import { XCircleIcon } from "@heroicons/react/solid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const FullProfileModal = (props) => {
  const [value, setValue] = React.useState(0);
  const [scoreCard, setScoreCard] = React.useState("");
  const [reportCard, setReportCard] = React.useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    let { campaignId } = props.campaign;
    let id = props.user;
    setScoreCard(
      `https://admin.thetalent.games/scorecard/index.html?${campaignId}/${id}`
    );
    setReportCard(
      `https://admin.thetalent.games/reportcart/index.html?${campaignId}/${id}`
    );
  }, [scoreCard, reportCard]);

  let fetchScoreCard = () => {
    const url = scoreCard;
    window.open(url + "/download", "_blank");
  };

  let fetchReportCard = () => {
    const url = reportCard;
    window.open(url + "/download", "_blank");
  };
  return (
    <div>
      <div className="bg-[#007E8C] px-2 py-4 flex flow-row justify-between">
        <div></div>
        <div>
          <h3 className="text-[#FFFFFF] ml-4 font-semibold  mt-[-2px]">
            Profile
          </h3>
        </div>
        <XCircleIcon
          onClick={props.handelNo}
          className="w-7 h-7 cursor-pointer "
          color="white"
        />
      </div>

      <div>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#007E8C",
                },
              }}
            >
              <Tab
                style={{
                  color: value === 0 ? "#007E8C" : "gray",
                  fontWeight: 500,
                  fontStyle: "normal",
                }}
                label="Score Card"
                {...a11yProps(0)}
              />
              <Tab
                style={{
                  color: value === 1 ? "#007E8C" : "gray",
                  fontWeight: 500,
                  fontStyle: "normal",
                }}
                label="Development Opportunities"
                {...a11yProps(1)}
              />
            </Tabs>
          </Box>

          <TabPanel value={value} index={0}>
            <button
              onClick={fetchScoreCard}
              className="text-xl text-black font-medium"
            >
              Download file
            </button>
            <iframe
              style={{
                width: "100%",
                height: "70vh",
              }}
              id="scoreCard"
              src={scoreCard}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <button
              onClick={fetchReportCard}
              className="text-xl text-black font-medium"
            >
              Download file
            </button>
            <iframe
              style={{
                width: "100%",
                height: "75vh",
              }}
              id="reportCard"
              src={reportCard}
            />
          </TabPanel>
        </Box>
      </div>
    </div>
  );
};

export default FullProfileModal;
